import {CSRFToken} from '../../@types/services/CSRFProtection';

function getTokenNode() {
	return document.querySelector('meta[name="csrf-token"]');
}

export function getCSRFToken(): CSRFToken | null {
    return getTokenNode()?.getAttribute('content') || null;
}

export function setCSRFToken(token: CSRFToken): void {
    const meta = getTokenNode();
    if (!meta) {
        throw new Error('CSRF-token meta-tag not found');
    }

    meta.setAttribute('content', token);
}
